import prodIndex from "./startup/prod"; 
import devIndex from "./startup/dev";

const indexFunction = process.env.NODE_ENV === 'development' ? devIndex : prodIndex;

indexFunction();